import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ElementSettings } from 'icreate/common/models/editor-viewer-element';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ElementSettingsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getSettings(elementId: string) {
        return await lastValueFrom(this.http.get<ElementSettings>(`${this.domain}/api/elementSettings/${elementId}`));
    }

    async getAllByMimicId(mimicId: string) {
        return await lastValueFrom(
            this.http.get<ElementSettings[]>(`${this.domain}/api/elementSettings/list/${mimicId}`)
        );
    }

    async create(elementSettings: ElementSettings): Promise<any> {
        return await lastValueFrom(
            this.http.post(`${this.domain}/api/elementSettings`, elementSettings, {
                headers: this.headers,
            })
        );
    }

    async update(elementSettings: ElementSettings) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/elementSettings/${elementSettings.id}`, elementSettings, {
                headers: this.headers,
            })
        );
    }

    async delete(elementsIds: string[]) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/elementSettings`, { body: { elementsIds } }));
    }

    async duplicate(changedIDs) {
        return await lastValueFrom(this.http.post(`${this.domain}/api/elementSettings/duplicate`, changedIDs));
    }
}
